import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isSuperAdminRole } from '../utils/auth';
import {
  isFieldVisible,
  allFieldsTrueMap,
  FIELD_CATALOG,
} from '../utils/fieldCatalog';

/**
 * Field / column visibility for list & form views.
 */
export function useFieldPrivilege() {
  const user = useSelector((state) => state.auth?.user);
  const isSuperAdmin = isSuperAdminRole(user?.role);
  const fieldPrivileges = user?.fieldPrivileges;

  const effective = useMemo(() => {
    if (isSuperAdmin) return allFieldsTrueMap();
    return fieldPrivileges && typeof fieldPrivileges === 'object'
      ? fieldPrivileges
      : allFieldsTrueMap();
  }, [isSuperAdmin, fieldPrivileges]);

  const canShowField = useCallback(
    (entity, accessor, view = 'list') => {
      if (isSuperAdmin) return true;
      return isFieldVisible(effective, entity, accessor, view);
    },
    [effective, isSuperAdmin]
  );

  const filterColumns = useCallback(
    (entity, columns) => {
      if (!Array.isArray(columns)) return columns;
      return columns.filter((col) => {
        const accessor = col.accessor || col.id || col.key;
        if (!accessor || accessor === 'actions' || accessor === '__actions') return true;
        return canShowField(entity, accessor, 'list');
      });
    },
    [canShowField]
  );

  return {
    canShowField,
    filterColumns,
    fieldPrivileges: effective,
    fieldCatalog: FIELD_CATALOG,
    isSuperAdmin,
  };
}

export default useFieldPrivilege;
